import React from 'react';
import styled from 'styled-components';
import PageHeader from 'src/components/common/PageHeader';
import { Hidden } from 'react-grid-system';
import Flex from 'src/components/common/Flex';

import { ParallaxProvider } from 'react-scroll-parallax';

const SkillsWrapper = styled.section`
  ${props => props.theme.spacing.sectionBottom};
  position: relative;

  .skill__icons {
    padding: 30px 0;
    width: 5%;
    @media ${props => props.theme.media.tablet} {
      padding: 10px 0;
      width: 10%;
    }

    svg {
      color: ${props => props.theme.primaryColor};
    }
  }
  .skills__word-clouds {
    @media ${props => props.theme.media.tablet} {
      display: none;
    }

    p {
      position: absolute;
      color: ${props => props.theme.accentColor};
      z-index: -1;
      left: 0;
      right: 0;
      font-weight: 900;
    }
    z-index: -1;
  }
`;

const Skills = () => (
  <SkillsWrapper>
    <ParallaxProvider>
      <PageHeader>Skills</PageHeader>
      <Flex justify="space-around" align="center">
        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599840542/html5_cch9ww.png'}
        />
        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599840635/css_1_ssgf5t.png'}
        />
        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599840696/javascript_fhppl8.png'}
        />
        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599840856/react_lamzic.png'}
        />
        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599841058/sass_gnlx87.png'}
        />
        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599841111/java_jlwfsc.png'}
        />
        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599840997/wordpress_ekboso.png'}
        />

        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599841198/typescript_du8aq3.png'}
        />
      </Flex>

      <PageHeader style={{ marginTop: 40 }}>Tools</PageHeader>

      <Flex justify="space-around" align="center">
        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599841401/photoshop_njzpml.png'}
        />

        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599841403/adobe_yaywse.png'}
        />

        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599841406/adobe_1_nmpqud.png'}
        />

        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599841408/adobe_3_zwwckw.png'}
        />

        <img
          className="skill__icons"
          alt=""
          src={
            'https://res.cloudinary.com/dedozyu83/image/upload/v1599841462/adobe_2_wrblgk.png'
          }
        />
        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599841587/android_hk1gyt.png'}
        />

        <img
          className="skill__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599841727/microsoft_bvmkpg.png'}
        />

      </Flex>
    </ParallaxProvider>
  </SkillsWrapper>
);

export default Skills;
